import { AxiosRequestConfig } from 'axios'
import queryString from 'query-string'

const getArticles = (
  url: string,
  params?: { [key: string]: any }
): AxiosRequestConfig => {
  const _params = params ?? {}
  _params.count = _params.count ?? 9
  _params.page = _params.page ?? 1

  return {
    method: 'GET',
    url: `${url}?${queryString.stringify(_params, { arrayFormat: 'bracket' })}`
  }
}

export default getArticles
